import { z } from 'zod'

/**
 * Job cost categories enum - includes misc for manual costs
 */
export const JobCostCategory = z.enum(['labor', 'parts', 'equipment', 'misc'])
export type JobCostCategory = z.infer<typeof JobCostCategory>

/**
 * Type guard for JobCostCategory
 */
export function isJobCostCategory(value: unknown): value is JobCostCategory {
  return JobCostCategory.safeParse(value).success
}

/**
 * Get display name for category
 */
export function getCategoryDisplayName(category: JobCostCategory): string {
  const displayNames: Record<JobCostCategory, string> = {
    labor: 'Labor',
    parts: 'Parts',
    equipment: 'Equipment',
    misc: 'Miscellaneous',
  }
  return displayNames[category]
}
